import './eventlogo.less'

import futureSummitsLogoWhite from 'assets/images/logos/futuresummits-logo-white.svg'
import {EventModel} from 'models/EventModel'
import React from 'react'
import {Link} from 'util/link'
import {style} from 'util/style'

export type EventLogoType = {
	event: EventModel
	white?: boolean
	powered?: boolean
	without_link?: boolean
	mod?: 'small' | 'medium' | 'summits' | 'events' | 'footer'
}

const styles = style('eventlogo')

export const EventLogo: React.FC<EventLogoType> = attrs => {
	const {event, white, powered, without_link, mod} = attrs
	if (!event) return null

	return (
		<Link
			to={without_link ? undefined : event.url}
			className={styles()
				.mod(mod)
				.mergeProps(attrs)}
		>
			<img
				className={styles('img')}
				src={event.getLogoSrc(white, powered) || futureSummitsLogoWhite.src}
				alt={event.title}
				title={event.title}
			/>
		</Link>
	)
}
